import React, { useState } from "react";
import DoneIcon from "@mui/icons-material/Done";
import { toast } from "react-toastify";
import moment from "jalali-moment";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import MuiButton from "../../shares/MuiButton";
import SizeTextGrid from "../../shares/SizeTextGrid";
import BasketOrderCard from "../create-order/BasketOrderCard";
import PanelTable from "../../shares/PanelTable";
import MuiPagination from "../../shares/MuiPagination";
import { useUserData } from "../../../context/UserDataContext";
import useFetch from "../../../context/useFetch";
import ShowRingSizes from "../create-order/ShowRingSizes";
import AddRingTabThree from "../create-order/AddRingTabThree";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReturedOrderAddRing from "./add-item/ReturedOrderAddRing";
import ReturnedBasketOrderCard from "./add-item/ReturnedBasketOrderCard";
import { fixNumbers } from "../../../utils";
import { showNumSix } from "../../../constants/constants";

const headersList = [
  { colName: "code", name: "کد" },
  { colName: "brand_name", name: "برند" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "seeـweights", name: "مشاهده وزن‌ها" },
  { colName: "add_ring", name: "افزودن" },
];
const mobileHeadersList = [
  { colName: "code", name: "کد" },
  { colName: "show_name", name: "نام" },
  { colName: "gender", name: "سن" },
  { colName: "color", name: "رنگ" },
  { colName: "brand_name", name: "برند" },
];
const dataKey = ["code", "brand_name", "show_name", "gender", "color"];

const ReturnBoxInside = (props) => {
  const [userSelectedRing, setUserSelectedRing] = useState([]);

  const { userData } = useUserData();
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const [ringsList, setRingsList] = useState({ results: [] });
  const GetRingsApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/user_get_order_item_history`,
    pagination: paginationPageInfo,

    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      // setPageData(res);
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRingsList({ results: [] });

    GetRingsApi.reFetch();
  };

  const removeRing = (ind) => {
    let before = [...userSelectedRing];
    let d = before[ind];

    before.splice(ind, 1);
    setUserSelectedRing(before);
  };
  const updateRingNumUsingIndex = (ringIndex, numIndex, newValue) => {
    let before = [...userSelectedRing];

    before[ringIndex]["nums"][numIndex] = fixNumbers(newValue);

    setUserSelectedRing(before);
  };
  // const handleEditRing = (order_item_id , selected_ring)=>{
  //   setOrderItemEditRing(order_item_id);
  //   setSelectedBangle(selected_ring);
  // }
  const updateRingDateUsingIndex = (ringIndex, newValue) => {
    let before = [...userSelectedRing];

    before[ringIndex]["date"] = newValue;

    setUserSelectedRing(before);
  };

  const AddRing = (newItem, itemNums, selectedUser = null) => {
    let sz = itemNums.length;
    let before = [...userSelectedRing];
    if (
      before.some(
        (ri) =>
          ri.ring.id == newItem.id &&
          ri.ring.gender == newItem.gender &&
          newItem.color == ri.ring.color
      )
    ) {
      toast.error("النگو قبلا اضافه شده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setUserSelectedRing([
        ...before,
        {
          ring: newItem,
          nums: itemNums,
        },
      ]);
    }
  };

  const buttonsList = [
    {
      label: "مشاهده وزن‌ها",
      component: (it) => <ShowRingSizes selectedRow={it} />,
    },
  ];
  const actionsList = [
    {
      label: "افزودن",
      component: (it) => (
        <ReturedOrderAddRing AddRing={AddRing} selectedRow={it} />
      ),
    },
  ];

  const [postOrderItem, setPostOrderItem] = useState([]);
  const createOrderItems = useFetch({
    method: "post",
    url: "ReturnOrderItem_Service",
    data: postOrderItem,
    argFunc: (res) => {
      setUserSelectedRing([]);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const createOrder = useFetch({
    method: "post",
    url: "ReturnOrder_Service",
    data: { creator: userData.username },
    argFunc: (res) => {
      let order_item = [];
      userSelectedRing.map((item, index) => {
        order_item.push({
          bangle: item.ring.id,
          return_order: res.id,
          size_one_num: item.nums[0] !== "" ? parseInt(item.nums[0]) : 0,
          size_two_num: item.nums[1] !== "" ? parseInt(item.nums[1]) : 0,
          size_three_num: item.nums[2] !== "" ? parseInt(item.nums[2]) : 0,
          size_four_num: item.nums[3] !== "" ? parseInt(item.nums[3]) : 0,
          size_five_num: item.nums[4] !== "" ? parseInt(item.nums[4]) : 0,

          size_six_num: showNumSix
            ? item.nums[5] !== "" && item.nums[5] !== undefined
              ? parseInt(item.nums[5])
              : 0
            : 0,
          // total_order_weight:,
        });
      });

      setPostOrderItem(order_item);
      createOrderItems.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const get_total_weight = () => {
    let total = 0;
    userSelectedRing.map((ri, ind) => {
      ri.nums.map((number, index) => {
        if (index == 0) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_one_weight);
          }
        }
        if (index == 1) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_two_weight);
          }
        }
        if (index == 2) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_three_weight);
          }
        }
        if (index == 3) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_four_weight);
          }
        }
        if (index == 4) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_five_weight);
          }
        }
        if (index == 5) {
          if (number !== "") {
            total += parseInt(number) * parseFloat(ri.ring.size_six_weight);
          }
        }
      });
    });

    return total.toFixed(3);
  };
  return (
    <>
      <div className="md:border md:rounded-md md:mb-4">
        <div className="hidden md:block text-center bg-red-600 rounded-t-md px-2 py-1">
          <span className="font-bold text-white text-lg">سبد مرجوعی شما</span>
        </div>

        <div className="pb-6 grid grid-cols-12 gap-x-2 items-center md:p-2">
          <div className="col-span-8">
            <span className="text-xs md:text-base">
              برای نهایی کردن سفارش خود روی دکمه ثبت کلیک کنید.
            </span>
          </div>

          <div className="col-span-4 text-left">
            <MuiButton
              onClick={() => createOrder.reFetch()}
              disabled={(userSelectedRing.length === 0) | createOrder.loading}
              variant="contained"
              icon={<DoneIcon />}
              color="primary"
              text="ثبت"
            />
          </div>
        </div>
        <SizeTextGrid
          haveExtraCol
          have5Col
          haveTotalWeight
          get_total_weight={get_total_weight}
        />

        <div className="md:max-h-96 md:overflow-scroll md:px-2 md:mb-2">
          {userSelectedRing.map((item, index) => {
            return [
              <ReturnedBasketOrderCard
                fromCreateOrder={true}
                updateRingNumUsingIndex={updateRingNumUsingIndex}
                updateRingDateUsingIndex={updateRingDateUsingIndex}
                removeRing={removeRing}
                item={item}
                ringIndex={index}
              />,
            ];
          })}
        </div>
      </div>
      <PanelTable
        header="خریدهای قبلی:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={ringsList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
  );
};

export default ReturnBoxInside;
